import React  , {useState} from 'react'
import data from '../../card/configImg.json'
import "./extends2.css";

export function ExtendFarplane(){
    const ifDisable = { display: 'none' };
    const elseDisable = { display: "block" };
     const notSelected = { userSelect: 'none', WebkitUserSelect: 'none' }
    const parrafhStyle = { textAlign: "center" ,fontSize: "x-small" , color:"aliceblue" , marginBottom: "5%" }
   
    const [reViewImg , setReViewImg] = useState(ifDisable)
    const [reViewMetric , setReViewMetric] = useState(ifDisable)
    const [reViewPublish , setReViewPublish] = useState(ifDisable)

    function Farplane3() {
        setReViewImg(elseDisable)
        setReViewMetric(ifDisable)
        setReViewPublish(ifDisable)
        return
    }
      function Farplane4() {
        setReViewImg(ifDisable)
        setReViewMetric(elseDisable)
        setReViewPublish(ifDisable)
        return
    }
      function Farplane5() {
        setReViewImg(ifDisable)
        setReViewMetric(ifDisable)
        setReViewPublish(elseDisable)
        return
    }
  return(
    < >
    <div id='ContainerFarplane' style={notSelected} >
      <h1 id="Farplane" lang='es'> Sobre nosotros sobre mí  </h1>
      <p id='Farplane1' lang='es'>
        Coronados del bien es mi página web o blog porque en un mundo donde la información y la creatividad fluyen sin cesar , Coronados del bien se presenta como un espacio único y dinámico donde podrás explorar y disfrutar … porque yo creo en la importancia de la creatividad , la curiosidad y la exploración y que ver asombrar a otra persona no sea solo por algo netamente material o porque encontrarse sorprendido no esté relacionado a una cadena de acontecimientos pocos casuales entonces esto es una construcción un diseño una implementación una imagen una distribución propia "es que acá todo está tipeado por mí porque en este contexto la cuestión de fondo es programar" . La web (www.) era originalmente para muchos como yo un espacio de navegación de investigación de buscar esa información que había comprendido no del todo escuchar música de la que habíamos escuchado solamente como se llamaba y hoy cada vez que uso la web es todo "entretenimiento" y si quisiera reflejar realmente algo poco productivo sería muy propio encontrar un momento de tu vida donde alguien alrededor de vos paso más de una hora viendo videos que carecen de un sentido extrovertido o aunque sea original de este modo creo que pierdo el tiempo aunque sea entretenida esta www repleta de acontecimientos ajenos y de redes sociales. En este caso quiero resaltar que no ahí acá ensayo de algún contexto podrías encontrar alguna respuesta que antes era pregunta, no trata de convencer a nadie solo hablo de libertades que se explican no del todo claro los textos son funcionales al contexto no son maneras propias de comprender.
        A mí me parece si proporcionar contenido de alta calidad y relevancia en áreas como artículos de interés general, música y "navegación" con el objetivo de inspirar, educar y entretener con sensatez … es un ejemplo de programación web una creación con un fin y código que tipié y dediqué para vos …  
      </p>
      <p id='Farplane2' lang='es'>
        Sitio web  .  visita el sitio web  .   Ingresar a coronados del bien  .  vistita este sitio web  .    
        Navega por una web segura ,rápida y nueva para vos .  Sitio web con URL y Dominios originales  .
        Información , artículos curiosos , experiencia responsiva  .  Sitio para navegar sin preguntas ...silencio solo vos y sin respuestas sin pedir explicaciones .   Visita mi web es gratis es única .
      </p>
    </div>
    <div id='Farplane3' lang='es' style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <ul>
            <li onClick={() => { Farplane3(); }}>CODIGO PROGRAMA</li>
            <li onClick={() => { Farplane4(); }}>METRICAS</li>
            <li onClick={() => { Farplane5(); }}>PROPAGANDAS</li>
        </ul>
    </div>
    <section className='Farplane4' lang='es' style={ reViewImg  } >
        <p style={ parrafhStyle  }>Esta son imágenes del código que hace funcionar esta Web</p>
        <div style = {notSelected}>
            <article id='Farplane4' >
                <figure>
                    <img src= {`${data[0].img}`} alt={`${data[0].alt}`} title = {`${data[0].title}`} />
                    <figcaption>{`${data[0].name}`}</figcaption>
                </figure>
            </article>
            <article id='Farplane4'>
                <figure>
                    <img src= {`${data[1].img}`} alt={`${data[1].alt}`} title = {`${data[1].title}`} />
                    <figcaption>{`${data[1].name}`}</figcaption>
                </figure>
            </article>
            <article id='Farplane4'>
                <figure>
                    <img src= {`${data[2].img}`} alt={`${data[2].alt}`} title = {`${data[2].title}`}  />
                    <figcaption>  {`${data[2].name}`}</figcaption>
                </figure>
            </article>
            <article id='Farplane4'>
                <figure>
                    <img src= {`${data[3].img}`} alt={`${data[3].alt}`} />
                    <figcaption>{`${data[3].name}`}</figcaption>
                </figure>
            </article>
            <article id='Farplane4'>
                <figure>
                    <img src= {`${data[4].img}`} alt={`${data[4].alt}`} title = {`${data[4].title}`} />
                    <figcaption>{`${data[4].name}`}</figcaption>
                </figure>
            </article>
            <article id='Farplane4'>
                <figure>
                    <img src= {`${data[5].img}`} alt={`${data[5].alt}`} />
                    <figcaption>{`${data[5].name}`}</figcaption>                    
                </figure>
            </article>  
        </div>
    </section>
    <section className='Farplane5' lang='es' style={reViewMetric}>
        <p style={parrafhStyle}>Esta son imágenes del funcionamiento y visitas Web</p>
        <div  style = {notSelected}>
        <article id='Farplane5A'>
            <figure>
                <img src= {`${data[6].img}`} alt={`${data[6].alt}`} title={`${data[6].title}`}/>
                <figcaption>{`${data[6].name}`}</figcaption>
            </figure>
        </article>
        <article id='Farplane5B'>
            <figure>
                 <img src= {`${data[7].img}`} alt={`${data[7].alt}`} />
              <figcaption>{`${data[7].name}`}</figcaption>           
            </figure>
        </article>
        <article id='Farplane5C'>
            <figure>
                <img src= {`${data[8].img}`} alt={`${data[8].alt}`} title= {`${data[8].title}`}  />
                <figcaption>{`${data[8].name}`}</figcaption>   
            </figure>
        </article>
        <article id='Farplane5'>
            <figure>
                <img src= {`${data[9].img}`} alt={`${data[9].alt}`} title= {`${data[9].title}`}  /> 
                <figcaption>{`${data[9].name}`}</figcaption>   
            </figure>
        </article>
        <article id='Farplane5F'>
            <figure>
                <img src= {`${data[10].img}`} alt={`${data[10].alt}`}  title= {`${data[10].title}`}  />
                <figcaption>{`${data[10].name}`}</figcaption>   
            </figure>
        </article>
        <article id='Farplane5'>
            <figure>
                <img src= {`${data[11].img}`} alt={`${data[11].alt}`}   title= {`${data[11].title}`}  />
                <figcaption>{`${data[11].name}`}</figcaption>   
            </figure>
        </article> 
        </div>
    </section>
     <section className='Farplane6' lang='es' style={reViewPublish}>
        <p style={parrafhStyle}>Esta son imagenes y videos publicitarios Web</p>
        <div>
        <article >
            <img  src= {`${data[12].img}`} alt={`${data[12].alt}`} />
        </article>
        <article >
            <video src={`${data[13].img}`} autoPlay= {true} muted= {true} controls= {true} ></video>
        </article>
        <article>
            <video id='video1' src={`${data[14].img}`} autoPlay= {true} muted= {true} controls= {true} ></video>
        </article>
        </div>
     </section>
    </>
  )
  
}
